
@for (toast of notificationService.toasts; track toast) {
    @if (isTemplate(toast)) {
        <ngb-toast [autohide]="toast.autohide || true" [delay]="toast.delay || 5000" (hide)="notificationService.removeToast(toast)">
            <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        </ngb-toast>
    } @else {
        <ngb-toast [autohide]="toast.autohide || true" [delay]="toast.delay || 5000" (hide)="notificationService.removeToast(toast)" [class]="{'bg-success': toast.type === 'success', 'bg-danger': toast.type === 'danger', 'bg-warning': toast.type === 'warning', 'text-light': toast.type === 'success' || toast.type === 'warning' || toast.type === 'danger'}">
            <ng-template ngbToastHeader>
                <span class="me-auto text-light">
                    @switch (toast.type) {
                        @case ('success') { <i class="fa-solid fa-circle-check" aria-hidden="true"></i> }
                        @case ('danger') { <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i> }
                        @case ('warning') { <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i> }
                    }
                </span>
            </ng-template>
            <span [innerHTML]="toast.textOrTpl"></span>
        </ngb-toast>
    }
}
